import { render } from "./WarrantyDetailsContainer.vue?vue&type=template&id=518b3a70"
import script from "./WarrantyDetailsContainer.vue?vue&type=script&lang=js"
export * from "./WarrantyDetailsContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__